export const compare = (a, b) => {
  if (a > b) {
    return 1;
  } else if (a < b) {
    return -1;
  }
  return 0;
};



// WEBPACK FOOTER //
// ./src/screens/Feeds/constants/functions.js